// Branch renderers for TodaySectionList (lint split).
import { Box, Typography } from '@mui/material';
import TaskListSimple from '@/features/tasks/components/lists/TaskListSimple';
import TaskListSortableMobile from '@/features/tasks/components/lists/TaskListSortableMobile';
import TaskList from '@/features/tasks/components/lists/TaskList';
import TodayEmptyMessageContent from '@/features/today/components/TodayEmptyMessageContent';

export function renderBattlefieldTodayList({
  variant,
  tasks,
  totalTasksCount,
  listId,
  taskType,
  leftSwipeAction,
  topActionableTaskId,
  showPlayButtonAlways,
  tasksMap,
  inProgressMessage,
  emptyMessage,
  dragEnabled,
  dragType,
  menuSurface,
  swipeTeaserTaskId,
  onSwipeTeaserEnd,
}) {
  if (variant === 'sortable') {
    return (
      <TaskListSortableMobile
        displayTasks={tasks}
        totalTasksCount={totalTasksCount}
        listId={listId}
        taskType={taskType}
        leftSwipeAction={leftSwipeAction}
        topActionableTaskId={topActionableTaskId}
        showPlayButtonAlways={showPlayButtonAlways}
        tasksMap={tasksMap}
        inProgressMessage={inProgressMessage}
        emptyMessage={emptyMessage}
        swipeTeaserTaskId={swipeTeaserTaskId}
        onSwipeTeaserEnd={onSwipeTeaserEnd}
      />
    );
  }

  return (
    <TaskListSimple
      tasks={tasks}
      leftSwipeAction={leftSwipeAction}
      topActionableTaskId={topActionableTaskId}
      showPlayButtonAlways={showPlayButtonAlways}
      tasksMap={tasksMap}
      dragEnabled={dragEnabled}
      listId={listId}
      taskType={dragType}
      menuSurface={menuSurface}
    />
  );
}

export function renderDesktopTodayList({
  tasks,
  selectedTaskIds,
  onSelectionChange,
  topActionableTaskId,
  showPlayButtonAlways,
  menuSurface,
  variant,
  dragEnabled,
  dragType,
  taskType,
  listId,
}) {
  return (
    <TaskList
      tasks={tasks}
      selectedTaskIds={selectedTaskIds}
      onSelectionChange={onSelectionChange}
      view="today"
      indentationType="none"
      showBreadcrumbs
      topActionableTaskId={topActionableTaskId}
      showPlayButtonAlways={showPlayButtonAlways}
      menuSurface={menuSurface}
      isSortable={variant === 'sortable'}
      dragEnabled={dragEnabled || variant === 'sortable'}
      dragType={dragType ?? taskType}
      listId={listId}
      id={listId}
      disableStructuralNav
      listTabIndex={tasks.length > 0 ? 0 : -1}
      itemTabIndex={-1}
    />
  );
}

export function renderEmptySortableDropTarget({
  setEmptyDropRef,
  totalTasksCount,
  inProgressMessage,
  emptyMessage,
}) {
  return (
    <Box ref={setEmptyDropRef}>
      {totalTasksCount > 0 ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: 'italic', opacity: 0.7 }}
        >
          {inProgressMessage}
        </Typography>
      ) : (
        <TodayEmptyMessageContent>{emptyMessage}</TodayEmptyMessageContent>
      )}
    </Box>
  );
}
